import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { useAuth } from './lib/auth.js';
import { LoginPage } from './pages/Login.js';
import { MeetingPage } from './pages/Meeting.js';
import { MeetingsPage } from './pages/Meetings.js';
import { NewMeetingPage } from './pages/NewMeeting.js';
import { RecorderPage } from './pages/Recorder.js';
import { UploadPage } from './pages/Upload.js';
import { VocabularyPage } from './pages/Vocabulary.js';

export function App(): JSX.Element {
  const { user, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="page">
        <p className="muted">{t('common.loading')}</p>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/meetings" replace />} />
        <Route path="/meetings" element={<MeetingsPage />} />
        <Route path="/meetings/new" element={<NewMeetingPage />} />
        <Route path="/meetings/:id" element={<MeetingPage />} />
        <Route path="/meetings/:id/record" element={<RecorderPage />} />
        <Route path="/meetings/:id/upload" element={<UploadPage />} />
        <Route path="/vocabulary" element={<VocabularyPage />} />
        <Route path="*" element={<Navigate to="/meetings" replace />} />
      </Route>
    </Routes>
  );
}
